import StaticClass from "../../../../../utils/staticClass";

const XuatThongTin = ({ dataThuaDat, dataKienTruc, dataQuyHoach, dataQuyHoachPhanKhu }) => {
  let listTienDo = [
    "-",
    "Cơ bản hoàn thành",
    "Đang triển khai",
    "Chưa triển khai",
    "Chậm triển khai",
  ];

  let newWin = window.open("", "", "width=1024,height=768");
  newWin.document.open();
  newWin.document.write("<html>");
  newWin.document.write("<head>");
  newWin.document.write(`
    <style>
        *{padding: 0;
            margin: 0;
            box-sizing: border-box;
            font-family: 'Roboto', ;
            line-height: 1.2
        }

        @media print
        {    
            .no-print, .no-print *
            {
                display: none !important;
            }
        }

        .thong-tin-thua-dat{
            width: 400px;
            border: 1px solid;
            padding: 20px;
        }

        .thong-tin-kien-truc{
            width: 730px;
            border: 1px solid;
            padding: 20px;
        }

        .title{
            font-size: 16pt;
            font-weight: bold;
            margin-bottom: 15px;
            padding-left: 20px;
        }
        
        .group{
            display: flex;
            font-size: 12pt;
            margin-bottom: 5pt;
        }
        
        .sub-title{
            min-width: 130px;
        }

        .sub-title-pk{
          min-width: 200px;
      }
        
        .date{
            margin-top: 15px;
            font-size: 14pt;
            padding-left: 20px;
        }
        
        .sub-value{
            font-weight: 600;
            text-align: justify;
        }

    </style>`); // your css file comes here.

  newWin.document.write(
    `<link rel="stylesheet" href="https://openlayers.org/en/v5.3.0/css/ol.css" type="text/css">`
  );
  newWin.document.write(
    '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">'
  );
  newWin.document.write(
    `<link href="https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap&subset=vietnamese" rel="stylesheet">`
  );
  newWin.document.write(
    `<script src="https://unpkg.com/axios/dist/axios.min.js"></script>`
  );
  newWin.document.write(
    `<script src="https://cdn.polyfill.io/v2/polyfill.min.js?features=requestAnimationFrame,Element.prototype.classList,URL"></script>`
  );
  newWin.document.write(
    `<script src="https://cdnjs.cloudflare.com/ajax/libs/openlayers/3.20.1/ol.js" type="text/javascript"></script>`
  );
  newWin.document.write("</head>");
  newWin.document.write(`
    <body>
    <div>
        <div class="thong-tin-thua-dat">
          <div class="title">THÔNG TIN THỬA ĐẤT</div>
          <div>
            <div class="group">
              <div class="sub-title">Tỉnh/Thành:</div>
              <div class="sub-value">${dataThuaDat ? dataThuaDat.TenTinh : " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Quận/Huyện:</div>
              <div class="sub-value">${dataThuaDat ? dataThuaDat.TenHuyen : " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Phường/Xã:</div>
              <div class="sub-value">${dataThuaDat ? dataThuaDat.TenPhuong : " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Số hiệu thửa đất:</div>
              <div class="sub-value">${dataThuaDat ? dataThuaDat.SoThua : " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Số tờ bản đồ:</div>
              <div class="sub-value">${dataThuaDat ? dataThuaDat.SoToBD : " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Diện tích:</div>
              <div class="sub-value">${dataThuaDat ? dataThuaDat.DienTich : " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Loại đất:</div>
              <div class="sub-value">${dataThuaDat ? dataThuaDat.LoaiDat : " "}</div>
            </div>
          </div>
          <div class="date">Đà Nẵng, ngày ..../..../....</div>
        </div>

        <p style="page-break-after: always;"/>
        <div class="clear"/>
        <br/>

        <div class="thong-tin-kien-truc">
          <div class="title">THÔNG TIN KIẾN TRÚC</div>
          <div>
            <div class="group">
              <div class="sub-title">Tên khu vực:</div>
              <div class="sub-value">${dataKienTruc && dataKienTruc.TenKhuVuc ? dataKienTruc.TenKhuVuc : " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Chỉ giới XD:</div>
              <div class="sub-value">${dataKienTruc && dataKienTruc.ChiGioiXD ? dataKienTruc.ChiGioiXD : " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Tầng cao XD:</div>
              <div class="sub-value">${dataKienTruc && dataKienTruc.TangCaoXD ? dataKienTruc.TangCaoXD : " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Chiều cao tầng:</div>
              <div class="sub-value">${dataKienTruc && dataKienTruc.ChieuCaoTang ? dataKienTruc.ChieuCaoTang : " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Cốt nền:</div>
              <div class="sub-value">${dataKienTruc && dataKienTruc.CotNen ? dataKienTruc.CotNen : " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Quyết định khác:</div>
              <div class="sub-value">${dataKienTruc && dataKienTruc.QDKhac ? dataKienTruc.QDKhac : " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Mật độ xây dựng:</div>
              <div class="sub-value">${dataKienTruc && dataKienTruc.MatDoXD ? dataKienTruc.MatDoXD : " "}</div>
            </div>
          </div>
          <div class="date">Đà Nẵng, ngày ..../..../....</div>
        </div>

        <p style="page-break-after: always;"/>
        <div class="clear"/>
        <br/>

        <div class="thong-tin-thua-dat">
          <div class="title">THÔNG TIN QUY HOẠCH</div>
          <div>
            <div class="group">
              <div class="sub-title">Tên dự án:</div>
              <div class="sub-value">${dataQuyHoach && dataQuyHoach.Tendoan ? dataQuyHoach.Tendoan : " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Quận/Huyện:</div>
              <div class="sub-value">${dataQuyHoach && dataQuyHoach.TENHUYEN ? dataQuyHoach.TENHUYEN: " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Phường/Xã:</div>
              <div class="sub-value">${dataQuyHoach && dataQuyHoach.TenPhuong ? dataQuyHoach.TenPhuong: " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Diện tích (ha):</div>
              <div class="sub-value">${dataQuyHoach && dataQuyHoach.DienTich ? dataQuyHoach.DienTich: " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Chủ đầu tư:</div>
              <div class="sub-value">${dataQuyHoach && dataQuyHoach.ChuDauTu ? dataQuyHoach.ChuDauTu: " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Điều hành dự án:</div>
              <div class="sub-value">${dataQuyHoach && dataQuyHoach.Dieuhanhduan ? dataQuyHoach.Dieuhanhduan: " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Quyết định pháp lý:</div>
              <div class="sub-value">${dataQuyHoach && dataQuyHoach.Quyetdinhphaply ? dataQuyHoach.Quyetdinhphaply: " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Năm ra QĐ:</div>
              <div class="sub-value">${dataQuyHoach && dataQuyHoach.NamraQDphaply ? dataQuyHoach.NamraQDphaply: " "}</div>
            </div>

            <div class="group">
              <div class="sub-title">Năm quy hoạch:</div>
              <div class="sub-value">${dataQuyHoach && dataQuyHoach.NamQH ? dataQuyHoach.NamQH: " "}</div>
            </div>
          </div>
          <div class="date">Đà Nẵng, ngày ..../..../....</div>
        </div>
        
        <p style="page-break-after: always;"/>
        <div class="clear"/>
        <br/>
  
        <div class="thong-tin-kien-truc">
            <div class="title">THÔNG TIN QUY HOẠCH PHÂN KHU</div>
            <div>
              <div class="group">
                <div class="sub-title-pk">Mã phân khu:</div>
                <div class="sub-value">${dataQuyHoachPhanKhu && dataQuyHoachPhanKhu.MaPhanKhu ? dataQuyHoachPhanKhu.MaPhanKhu : " "}</div>
              </div>
  
              <div class="group">
                <div class="sub-title-pk">Tên phân khu:</div>
                <div class="sub-value">${dataQuyHoachPhanKhu && dataQuyHoachPhanKhu.TenPhanKhu ? dataQuyHoachPhanKhu.TenPhanKhu: " "}</div>
              </div>
  
              <div class="group">
                <div class="sub-title-pk">Mã quy hoạch chung:</div>
                <div class="sub-value">${dataQuyHoachPhanKhu && dataQuyHoachPhanKhu.MaQHChung ? dataQuyHoachPhanKhu.MaQHChung: " "}</div>
              </div>
  
              <div class="group">
                <div class="sub-title-pk">Diện tích (ha):</div>
                <div class="sub-value">${dataQuyHoachPhanKhu && dataQuyHoachPhanKhu.DienTich ? dataQuyHoachPhanKhu.DienTich: " "}</div>
              </div>
  
              <div class="group">
                <div class="sub-title-pk">Số quyết định pháp lý:</div>
                <div class="sub-value">${dataQuyHoachPhanKhu && dataQuyHoachPhanKhu.QuyetDinhPhapLy ? dataQuyHoachPhanKhu.QuyetDinhPhapLy: " "}</div>
              </div>
  
              <div class="group">
                <div class="sub-title-pk">Năm ra quyết định pháp lý:</div>
                <div class="sub-value">${dataQuyHoachPhanKhu && dataQuyHoachPhanKhu.NamRaQDPL ? StaticClass.formatDate(dataQuyHoachPhanKhu.NamRaQDPL): " "}</div>
              </div>
  
              <div class="group">
                <div class="sub-title-pk">Cơ quan phê duyệt dự án:</div>
                <div class="sub-value">${dataQuyHoachPhanKhu && dataQuyHoachPhanKhu.CoQuanpheDuyet ? dataQuyHoachPhanKhu.CoQuanpheDuyet: " "}</div>
              </div>
  
              <div class="group">
                <div class="sub-title-pk">Vị trí:</div>
                <div class="sub-value">${dataQuyHoachPhanKhu && dataQuyHoachPhanKhu.ViTri ? dataQuyHoachPhanKhu.ViTri: " "}</div>
              </div>
  
              <div class="group">
                <div class="sub-title-pk">Năm quy hoạch:</div>
                <div class="sub-value">${dataQuyHoachPhanKhu && dataQuyHoachPhanKhu.NamQH ? dataQuyHoachPhanKhu.NamQH: " "}</div>
              </div>

              <div class="group">
                <div class="sub-title-pk">Tình trạng:</div>
                <div class="sub-value">${dataQuyHoachPhanKhu && dataQuyHoachPhanKhu.TinhTrang ? listTienDo[`${dataQuyHoachPhanKhu.TinhTrang}`]: " "}</div>
              </div>
            </div>
            <div class="date">Đà Nẵng, ngày ..../..../....</div>
        </div>
      </div>   
    </body>
  `);
  newWin.document.close();
  newWin.moveTo(0, 0);
  newWin.resizeTo(window.screen.width, window.screen.height);
  setTimeout(function () {
    newWin.print();
  }, 1000);
};

export default XuatThongTin;
